var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.showIcon)?_c('div',{staticClass:"dropdown-account-crypto-system-icon",class:_vm.iconClass},[_vm._v(_vm._s(_vm.title))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }